export default {"src":"/_next/static/media/user-profile.b1405567.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};